import styled, { css } from "styled-components";
import { colors } from "./colors/color";

type LinkVariants = 'default' | 'dark';

type LinkColorSettings = {
    normal: string;
    hover: string;
}

const common = css`
    text-decoration: none;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    max-width: 100%;
`;


export const Link = styled.a<{colorSettings?: LinkColorSettings}>`
    
    ${common}

    color:${props => props.colorSettings?.normal || colors.link.default.normal};
    
    svg {
        fill:${props => props.colorSettings?.normal || colors.link.default.normal};
    }
    &:hover, :hover svg{
        color:${props => props.colorSettings?.hover || colors.link.default.hover};
    }
    &:hover svg {
        fill:${props => props.colorSettings?.hover || colors.link.default.hover};
    }
`;

export const DarkLink = styled.a<{variant?:LinkVariants}>`
    
    ${common}
    
    color:${props => props.theme.colors.link.dark.normal};

    svg {
        fill:${props => props.theme.colors.link.dark.normal};
    }

    &:hover {
        color:${props => props.theme.colors.link.dark.hover};
    }
    &:hover svg {
        fill:${props => props.theme.colors.link.dark.hover};
    }
`;